import { TerminalSettingsService } from './shared/layout/terminal/terminal-settings.service';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
    DataTableModule,
    AutoCompleteModule,
    ToggleButtonModule,
    InputMaskModule,
    EditorModule,
} from "primeng/primeng";
import { PaginatorModule } from "primeng/primeng";
import {
    ModalModule,
    TabsModule,
    TooltipModule,
    PopoverModule,
} from "ngx-bootstrap";
import { UtilsModule } from "@shared/utils/utils.module";
import { AppCommonModule } from "@app/shared/common/app-common.module";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { FileUploadModule } from "ng2-file-upload";
import { FileUploadModule as PrimeNgFileUploadModule } from "primeng/primeng";
import { AppModule } from "@app/app.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BeginComponent } from "./begin/begin.component";
import { CongressComponent } from "./congress.component";
import { CongressRoutingModule } from "./congress-routing.module";
import { HeaderTopBarComponent } from "./shared/layout/header-top-bar/header-top-bar.component";
import { EventsComponent } from "./events/events.component";
import { TerminalSettingsModalComponent } from './shared/layout/terminal/terminal-settings-modal.component';
import { LoginService } from "account/login/login.service";
import { TerminalSettingsServiceProxy } from "@shared/service-proxies/service-proxies";
import { JoinAnuuityComponent } from "./join-anuuity/join-anuuity.component";
import { CredentialComponent } from "./credential/credential.component";
import { EventModule } from '@app/event/event.module';
import { CheckoutModalComponent } from './shared/layout/checkout/checkout-modal/checkout-modal.component';
import { AgentSitefService } from './shared/layout/checkout/agent-sitef/agent-sitef.service';
import { AgentSitefComponent } from './shared/layout/checkout/agent-sitef/agent-sitef.component';
import { MenuPageComponent } from './shared/layout/menu-page/menu-page.component';
import { CongressWarnModalComponent } from './shared/layout/congress-warn-modal/congress-warn-modal.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        UtilsModule,
        DataTableModule,
        PaginatorModule,
        CongressRoutingModule,
        AutoCompleteModule,
        AppCommonModule,
        ToggleButtonModule,
        CurrencyMaskModule,
        FileUploadModule,
        PrimeNgFileUploadModule,
        InputMaskModule,
        EditorModule,
        AppModule,
        InfiniteScrollModule,
        EventModule
    ],
    exports: [CheckoutModalComponent, CongressWarnModalComponent],
    declarations: [HeaderTopBarComponent, CheckoutModalComponent, CongressWarnModalComponent, AgentSitefComponent, MenuPageComponent, TerminalSettingsModalComponent, BeginComponent, CongressComponent, EventsComponent, JoinAnuuityComponent, CredentialComponent],
    providers: [ LoginService, HeaderTopBarComponent, TerminalSettingsService, AgentSitefService, TerminalSettingsServiceProxy ]
})
export class CongressModule {}



// WEBPACK FOOTER //
// ./src/congress/congress.module.ts